import React from 'react';
import './Pages.css';

const SetArchive = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <h1>Set Archive</h1>
        <p>Browse through our extensive collection of sets from various years and categories.</p>
        <div className="archive-grid">
          {/* Placeholder for archive items */}
          {[1, 2, 3, 4, 5, 6].map((item) => (
            <div key={item} className="archive-item">
              <div className="archive-item-image"></div>
              <h3>Set #{item}</h3>
              <p>Year: 202{item}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SetArchive; 